import FilterOutlined from '@ant-design/icons/lib/icons/FilterOutlined';
import Tag from 'antd/lib/tag';
import { theme } from 'antd/lib';

export const SelectedMarketAwardDispatchFilterButton = ({ value, onClear }: { value: string; onClear: () => void }) => {
    const { token: themeColors } = theme.useToken();

    const label = 'Market Award Dispatch';

    if (!label) return <></>;

    return (
        <Tag
            closable
            icon={<FilterOutlined />}
            color={themeColors.colorPrimary}
            onClose={onClear}
            title="Events displayed for this Market Award Dispatch. Click close button to clear this filter."
        >
            {label}
        </Tag>
    );
};
